import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
export default function () {
  extend('flarum/forum/components/DiscussionComposer', 'headerItems', function (items) {
    const tags = this.composer.fields.tags || [];
    const hasPtpTag = tags.some(tag => tag && tag.blomstraPtpProduct());
    if (!hasPtpTag) return;
    items.add('blomstraPtpNotice', m("div", {
      className: "Blomstra-Payments-ptp-notice"
    }, m("span", {
      className: "icon fas fa-lock"
    }), app.translator.trans('floxum-payments.forum.pay-to-post.composer-notice')), -10);
  });
}